
<textarea autocomplete="off" aria-required="true"
          class="form-control textarea form_field form_field_textarea"
          rows="4" [(ngModel)]="notizKanton"></textarea>
<div class="mt-15">
  <button class="btn btn-delete" (click)="delete()">
    <span class="glyphicon glyphicon-trash"></span>
  </button>
  <button class="btn btn-primary ml-15" (click)="save()">{{ "global.ok" | translate }}</button>
</div>
